// removed by extract-text-webpack-plugin
module.exports = {"shippingMethodSelector":"_2ZSQd","invalid":"_1MLbh","shippingMethod":"_1naGq","noShippingMethodAvailable":"_2xrvl","checkbox":"_-GGqy","checkboxLabel":"Hp7Ru","shippingMethodTitle":"_1v_Vx","shippingMethodSubtitle":"_3NGwU","shippingMethodPrice":"_3NOj7"};


//////////////////
// WEBPACK FOOTER
// ./banquet/components/Checkout/ShippingMethodSelector/index.sass
// module id = 1469
// module chunks = 1